import './style.scss';
import { Button, Input, Select } from 'antd';
import {
  IAPIServiceConfigItem,
  IGauthServiceType,
  IServiceAllEnvs,
  IServiceApplyConfig,
  IServiceStatus,
  ServiceBusiness,
} from '../../../model/api-modules';
import React, { useEffect, useState } from 'react';
import { GameEnvType, IGameEnvModel } from '../../../model/api-modules/env';
import { ServicesApplyModal } from './services-apply-modal';
import { ApplyMenuComponent } from './menu';
import { getLocaleLanguage, LanguageType, strToJson } from '../../../lib';
import { Mailto } from '../../../components/mailto';
import tipsWarn from '../../../assets/images/warn-yellow.png';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../store/reducers';
import getFormatMessage from '../../../locales/get-format-message';
import { getConfig } from '../../../config';
// import tipsIcon from '../../../assets/svg/devcloud-tips-icon.svg';
// import { DeployArea } from '../../../model';
import { associatedServicesData as associatedServicesJson } from './associated-service';
import {
  gauthApply,
  gauthModify,
  getAllEnvsServiceStatus,
} from '../../../api/services';
import { PermissionCheck } from '../../component/permission-check';
import { checkIsEditor, isVersionGreaterThan } from '../lib';
import { GauthStatus } from '../game-console';
import { messageError, messageSuccess } from '../../../components/message';

interface IProps {
  readonly selectedGameID: string;
  readonly selectedServerStatus: IServiceStatus[] | null;
  readonly selectedServiceConfig: IAPIServiceConfigItem;
  readonly selectedEnv: IGameEnvModel;
  readonly queryServiceStatus: (
    gameID: string,
    envID: string,
    serviceID: string
  ) => void;
  readonly allServicesStatus: Record<string, IServiceStatus[] | null>;
  readonly gauthStatus?: GauthStatus;
  readonly gauthRes?: Record<string, any>;
  readonly gauthCode?: IGauthServiceType | null;
  readonly getAuthInfo?: () => Promise<void>;
}

export const ServicesApplyComponent = (props: IProps) => {
  const [templateApplyStatus, setTemplateApplyStatus] =
    useState<boolean>(false); // 是否有已开通或正在申请的子服务
  const [templateApplyAllStatus, setTemplateApplyAllStatus] =
    useState<boolean>(false); // 子服务是否全部已开通或正在申请
  const [isClose, setIsClose] = useState<boolean>(false); // 是否下线
  const [showApplyModal, setShowApplyModal] = useState<boolean>(false);
  const [serviceAllEnvStatus, setServiceAllEnvStatus] = useState<
    Record<string, IServiceAllEnvs[] | null>
  >({});
  const currentStoreLanguage = getLocaleLanguage() || LanguageType.en_US;
  const jsonConfig = strToJson<IServiceApplyConfig>(
    props.selectedServiceConfig?.JsonConfig || ''
  );
  const [serviceDescriptionModalID, setServiceDescriptionModalID] = useState<
    number | null
  >(null);
  const [applyTime, setApplyTime] = useState<number>(3);
  const [applyDesc, setApplyDesc] = useState<string>('');
  const [gauthLoading, setGauthLoading] = useState<boolean>(false);
  const servicesConfig = useSelector(
    (state: IRootState) => state.games.allServiceConfig
  );
  // const deployArea: DeployArea = getConfig()?.deployArea;
  // const isWoa =
  //   deployArea === DeployArea.woa && getConfig().env === 'production';
  const allEnvList = useSelector((state: IRootState) => state.games.allEnvList);
  const allGames = useSelector((state: IRootState) => state.games.games);
  const associatedServicesData = Object.assign({}, associatedServicesJson);

  const toLowerCaseAndRemoveSpaces = (str: string) => {
    return str.toLowerCase().replace(/\s+/g, '');
  };

  useEffect(() => {
    let serviceItem =
      associatedServicesData[props.selectedServiceConfig.Name]?.services || [];
    const itemGos = JSON.parse(props.selectedEnv?.GosParams || '{}');
    if (props.selectedServiceConfig.Name === 'Matchmaking') {
      if (!isVersionGreaterThan(itemGos?.GameServiceVersion)) {
        serviceItem = [];
      }
    }
    if (props.selectedServiceConfig.Name === 'Battle') {
      if (
        !isVersionGreaterThan(itemGos?.GameServiceVersion) &&
        !serviceItem.includes('Matchmaking')
      ) {
        serviceItem.push('Matchmaking');
      }
    }

    if (props.selectedServerStatus) {
      let isOpenService = false;
      let isOpenAllService = true;
      let closeService = false;
      if (serviceItem.length !== 0) {
        serviceItem.forEach((item) => {
          const subserviceItem = props.selectedServerStatus?.find((it) => {
            return (
              it.subserviceName === toLowerCaseAndRemoveSpaces(item) &&
              (it.stage === 'applying' || it.stage === 'opened')
            );
          });
          const closeServiceItem = props.selectedServerStatus?.find((it) => {
            return (
              it.subserviceName === toLowerCaseAndRemoveSpaces(item) &&
              it.stage === 'opened' &&
              it.status === 2
            );
          });
          if (closeServiceItem) {
            closeService = true;
          }
          if (!subserviceItem) {
            isOpenAllService = false;
          } else {
            isOpenService = true;
          }
        });
      } else {
        const subserviceItem = props.selectedServerStatus?.find((it) => {
          return it.stage === 'applying' || it.stage === 'opened';
        });
        const closeServiceItem = props.selectedServerStatus?.find((it) => {
          return it.stage === 'opened' && it.status === 2;
        });
        if (closeServiceItem) {
          closeService = true;
        }
        if (!subserviceItem) {
          isOpenAllService = false;
        } else {
          isOpenService = true;
        }
      }
      const openedServiceItem = props.selectedServerStatus?.find((it) => {
        // 只要有开通的服务，就不走关停逻辑
        return it.stage === 'opened' && it.status === 1;
      });
      if (openedServiceItem) {
        closeService = false;
      }
      setTemplateApplyStatus(isOpenService);
      setTemplateApplyAllStatus(isOpenAllService);
      setIsClose(closeService);
      return;
    }
    setTemplateApplyStatus(false);
    setTemplateApplyAllStatus(false);
    setIsClose(false);
    getAllEnvStatus();
  }, [
    props.selectedEnv,
    props.selectedServiceConfig,
    props.selectedServerStatus,
    props.selectedGameID,
  ]);
  useEffect(() => {
    const currentURL = window.location.href;
    const parts = currentURL.split('/');
    const lastPart = parts[parts.length - 1];
    const serviceId = parseInt(lastPart, 10);
    setServiceDescriptionModalID(serviceId);
  }, []);

  const getAllEnvStatus = async () => {
    const res = await getAllEnvsServiceStatus(
      props.selectedGameID,
      props.selectedServiceConfig?.id?.toString()
    );
    if (res) {
      setServiceAllEnvStatus(res);
    }
  };

  // const isLiveCanNotApply = () => {
  //   const isLive = props.selectedEnv.Type === GameEnvType.Live;
  //   const isVoiceChat = /^voice\s+chat$/i.test(
  //     props.selectedServiceConfig.Name || ''
  //   );

  //   return isLive && !isVoiceChat;
  // };

  const isAllowApplyTips = () => {
    return templateApplyStatus && !isClose;
    // ||
    // props.selectedServerStatus === CommonStatusStep.Resolve ||
    // props.selectedServerStatus === CommonStatusStep.Pending
  };

  const isAllowApplyButton = () => {
    return templateApplyAllStatus || isClose;
  };

  const isDmpDevApplyDisabled = () => {
    if (props.selectedEnv && props.selectedServiceConfig) {
      if (props.selectedServiceConfig.Business === ServiceBusiness.DMP) {
        const keyList = Object.keys(serviceAllEnvStatus) || [];
        // let devOpen = false;
        let liveOpen = false;
        const openList: string[] = [];
        keyList.forEach((keyItem) => {
          const envStatusItem = serviceAllEnvStatus[keyItem];
          if (envStatusItem && envStatusItem.length !== 0) {
            const closeItem = envStatusItem.find(
              (statusItem) =>
                statusItem.stage === 'opened' && statusItem.status === 2
            );
            if (!closeItem) {
              envStatusItem.forEach((statusItem) => {
                if (
                  statusItem.stage === 'opened' &&
                  statusItem.status === 1 &&
                  openList.indexOf(keyItem) === -1
                ) {
                  openList.push(keyItem);
                }
              });
            }
          }
        });
        openList.forEach((openItem) => {
          const envItem = allEnvList.find(
            (item) => item.envIncrementID === Number(openItem)
          );
          // if (envItem?.envType === GameEnvType.Dev) {
          //   devOpen = true;
          // }
          if (envItem?.envType === GameEnvType.Live) {
            liveOpen = true;
          }
        });
        return liveOpen && props.selectedEnv.Type === GameEnvType.Dev;
      }
    }
    return false;
  };

  const renderApplySuccessTips = () => {
    const subserviceItem = props.selectedServerStatus?.find((it) => {
      return it.stage === 'opened';
    });
    const closeServiceItem = props.selectedServerStatus?.find((it) => {
      return it.stage === 'opened' && it.status === 2;
    });
    if (
      props.selectedServiceConfig.Name === 'Store' &&
      props.gauthStatus !== GauthStatus.HasPermissions &&
      subserviceItem &&
      !closeServiceItem
    ) {
      let tips = '';
      if (props.gauthStatus === GauthStatus.Expired) {
        tips = getFormatMessage('gauth_permission_expired');
      } else if (props.gauthStatus === GauthStatus.ApplyFailed) {
        tips = getFormatMessage('gauth_permission_apply_fail');
      } else if (props.gauthStatus === GauthStatus.Frozen) {
        tips = getFormatMessage('gauth_permission_frozen');
      } else if (props.gauthStatus === GauthStatus.Denied) {
        tips = getFormatMessage('gauth_permission_denied');
      } else if (props.gauthStatus === GauthStatus.Pending) {
        tips = getFormatMessage('gauth_permission_apply');
      } else {
        tips = getFormatMessage('gauth_permission_activated');
      }
      return (
        <div className="services-tips">
          <img src={tipsWarn} />
          {tips}
          <Mailto />
        </div>
      );
    }
    if (isAllowApplyTips() && !isDmpDevApplyDisabled()) {
      return (
        <div className="services-tips">
          <img src={tipsWarn} />
          {getFormatMessage('received_application_24_hours')}
          <Mailto />
        </div>
      );
    }
    return null;
  };

  // const renderTips = () => {
  //   if (
  //     isWoa &&
  //     props.selectedGameID === '47064606' &&
  //     props.selectedServiceConfig.Name === 'DS Hosting'
  //   ) {
  //     return (
  //       <div className="tips-content">
  //         <img src={tipsIcon} />
  //         {getFormatMessage('devcloud_tips')}
  //       </div>
  //     );
  //   }
  //   return null;
  // };

  const getDisabledTips = () => {
    // let disabledTips = getFormatMessage('can_not_apply_in_live');
    let service = '';
    if (props.selectedServiceConfig?.Name === 'Dynamic Update') {
      service = 'puffer';
    } else if (props.selectedServiceConfig?.Name === 'Launch Update') {
      service = 'dolphin';
    }
    let disabledTips = '';
    if (isClose) {
      disabledTips = getFormatMessage('service_close_tips');
    } else if (isDmpDevApplyDisabled()) {
      disabledTips = getFormatMessage('dmp_nonsupport_open_dev', {
        params: {
          service,
        },
      });
    }
    return disabledTips;
  };

  const handleGauthSubmit = async () => {
    setGauthLoading(true);
    // ret -1 请求参数无效 -2 无申请记录 -3 申请的权限已经过期，请重新续期 -4 申请的权限已经被冻结 -5 申请的权限待审批中 -6 申请的权限被拒，请修改申请单 -7 申请的权限已被撤回，请修改申请单
    if (
      (props.gauthRes?.res1?.ret === -2 || props.gauthRes?.res2?.ret === -2) &&
      props.gauthCode?.gauthServiceType
    ) {
      const [res1, res2] = await Promise.all([
        gauthApply(36, props.selectedGameID, {
          serviceType: props.gauthCode.gauthServiceType,
          applyMonth: applyTime,
          applyDesc,
        }),
        gauthApply(20, props.selectedGameID, {
          serviceType: props.gauthCode.gauthServiceType,
          applyMonth: applyTime,
          applyDesc,
        }),
      ]);
      if (res1?.ret === 1 && res2?.ret === 1) {
        if (props.getAuthInfo) {
          props.getAuthInfo();
        }
        setGauthLoading(false);
        return messageSuccess(getFormatMessage('platform_accessns_submit'));
      }
    } else if (
      (props.gauthRes?.res1?.ret === -3 ||
        props.gauthRes?.res2?.ret === -3 ||
        props.gauthRes?.res1?.ret === -6 ||
        props.gauthRes?.res2?.ret === -6) &&
      props.gauthRes?.res1?.data?.iId &&
      props.gauthRes?.res2?.data?.iId
    ) {
      const [res1, res2] = await Promise.all([
        gauthModify(36, props.selectedGameID, {
          flowId: props.gauthRes?.res1?.data?.iId,
          applyMonth: applyTime,
          applyDesc,
        }),
        gauthModify(20, props.selectedGameID, {
          flowId: props.gauthRes?.res2?.data?.iId,
          applyMonth: applyTime,
          applyDesc,
        }),
      ]);
      if (res1?.ret === 1 && res2?.ret === 1) {
        if (props.getAuthInfo) {
          props.getAuthInfo();
        }
        setGauthLoading(false);
        return messageSuccess(
          getFormatMessage('platform_accessns_submit_renewal')
        );
      }
    } else {
      setGauthLoading(false);
      messageError(getFormatMessage('application_failed'));
    }
  };

  const renderGauthApply = () => {
    const subserviceItem = props.selectedServerStatus?.find((it) => {
      return it.stage === 'opened';
    });
    const closeServiceItem = props.selectedServerStatus?.find((it) => {
      return it.stage === 'opened' && it.status === 2;
    });
    if (
      props.selectedServiceConfig.Name === 'Store' &&
      props.gauthStatus !== GauthStatus.HasPermissions &&
      subserviceItem &&
      !closeServiceItem
    ) {
      const gameItem = allGames.find(
        (item) => item.gameID === props.selectedGameID
      );
      const timeOptions = [
        {
          label: getFormatMessage('one_month'),
          value: 1,
        },
        {
          label: getFormatMessage('two_months'),
          value: 2,
        },
        {
          label: getFormatMessage('three_months'),
          value: 3,
        },
      ];

      if (
        props.gauthRes?.res1?.ret === -2 ||
        props.gauthRes?.res2?.ret === -2 ||
        props.gauthRes?.res1?.ret === -3 ||
        props.gauthRes?.res2?.ret === -3 ||
        props.gauthRes?.res1?.ret === -6 ||
        props.gauthRes?.res2?.ret === -6
      ) {
        let btnText = '';
        if (
          props.gauthRes?.res1?.ret === -3 ||
          props.gauthRes?.res2?.ret === -3 ||
          props.gauthRes?.res1?.ret === -6 ||
          props.gauthRes?.res2?.ret === -6
        ) {
          btnText = getFormatMessage('one_click_renewal');
        } else {
          btnText = getFormatMessage('submit_application');
        }
        return (
          <div className="gauth-apply-box">
            <div className="gauth-apply-title">
              {getFormatMessage('platform_access_application')}
            </div>
            <div
              className="gauth-apply-label"
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <div style={{ width: 250 }}>
                {getFormatMessage('platform_selection')}
              </div>
              <div style={{ width: 250 }}>
                {getFormatMessage('role_selection')}
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Select
                value={getFormatMessage('game_default_one')}
                disabled
                className="gauth-apply-select"
                style={{ width: 250 }}
              />
              <Select
                value={getFormatMessage('role_default_one')}
                disabled
                className="gauth-apply-select"
                style={{ width: 250 }}
              />
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '8px',
              }}
            >
              <Select
                value={getFormatMessage('game_default_two')}
                disabled
                className="gauth-apply-select"
                style={{ width: 250 }}
              />
              <Select
                value={getFormatMessage('role_default_two')}
                disabled
                className="gauth-apply-select"
                style={{ width: 250 }}
              />
            </div>
            <div className="gauth-apply-label">
              {getFormatMessage('game_selection')}
            </div>
            <Select
              value={
                gameItem
                  ? `${gameItem.gameName}(${gameItem.gameProjectCode})`
                  : ''
              }
              disabled
              className="gauth-apply-select"
            />
            {/* <div className="gauth-apply-label">{getFormatMessage('role_selection')}</div> */}
            {/* <Select
              value={getFormatMessage('role_default')}
              disabled
              className="gauth-apply-select"
            /> */}
            <div className="gauth-apply-label">
              {getFormatMessage('application_duration')}
              <span className="gauth-apply-label-red">*</span>
            </div>
            <Select
              options={timeOptions}
              value={applyTime}
              onChange={(value) => setApplyTime(value)}
              className="gauth-apply-select"
            />
            <div className="gauth-apply-label">
              {getFormatMessage('application_reason')}
              <span className="gauth-apply-label-red">*</span>
            </div>
            <Input.TextArea
              rows={3}
              value={applyDesc}
              onChange={(e) => setApplyDesc(e.target.value)}
              maxLength={200}
              placeholder={getFormatMessage('enter_application_reason')}
            />
            <div className="gauth-apply-btn-box">
              <Button
                className="gc-btn gc-btn-primary gauth-apply-btn"
                loading={gauthLoading}
                onClick={handleGauthSubmit}
                disabled={!applyDesc || !applyTime}
              >
                {btnText}
              </Button>
            </div>
          </div>
        );
      }
    }
    return null;
  };

  const renderDescription = (config: IServiceApplyConfig) => {
    const configItems = config[currentStoreLanguage];

    const renderApplyButton = () => {
      const subserviceItem = props.selectedServerStatus?.find((it) => {
        return it.stage === 'opened';
      });
      const closeServiceItem = props.selectedServerStatus?.find((it) => {
        return it.stage === 'opened' && it.status === 2;
      });
      if (
        props.selectedServiceConfig.Name === 'Store' &&
        props.gauthStatus !== GauthStatus.HasPermissions &&
        subserviceItem &&
        !closeServiceItem
      ) {
        return null;
      }

      const getBtnElement = (tips?: string, placement?: any) => (
        <PermissionCheck
          gameID={props.selectedGameID}
          envID={String(props.selectedEnv.id)}
          customCheck={(perms) =>
            checkIsEditor(
              { serviceName: props.selectedServiceConfig.Name },
              perms
            )
          }
          otherTips={tips}
          tipsPlacement={placement}
          preCheck={() => ({
            disabled: isAllowApplyButton() || isDmpDevApplyDisabled(),
            tips,
          })}
        >
          <Button
            className="gc-btn gc-btn-primary "
            onClick={() => setShowApplyModal(true)}
          >
            <span className="btn-text">
              {getFormatMessage('apply_to_start')}
            </span>
          </Button>
        </PermissionCheck>
      );
      if (isClose || isDmpDevApplyDisabled()) {
        return getBtnElement(getDisabledTips(), 'bottom');
      }
      return getBtnElement();
    };

    return (
      <div className="services-content">
        <div className="con-left">
          {/* {renderTips()} */}
          <div className="con-title">{props.selectedServiceConfig.Name}</div>
          <div className="con-desc">{configItems?.description || ''}</div>
          {renderApplySuccessTips()}
          <div className="con-btn">{renderApplyButton()}</div>
          {renderGauthApply()}
        </div>
      </div>
    );
  };

  const renderDocLinks = (config: IServiceApplyConfig) => {
    const subserviceItem = props.selectedServerStatus?.find((it) => {
      return it.stage === 'opened';
    });
    const closeServiceItem = props.selectedServerStatus?.find((it) => {
      return it.stage === 'opened' && it.status === 2;
    });
    if (
      props.selectedServiceConfig.Name === 'Store' &&
      props.gauthStatus !== GauthStatus.HasPermissions &&
      subserviceItem &&
      !closeServiceItem
    ) {
      return null;
    }

    const configItems = config[currentStoreLanguage];
    if (configItems?.docLink) {
      return configItems.docLink.map((item, index) => {
        return (
          <a
            href={
              item.url.indexOf(getConfig().consoleURL) !== -1
                ? item.url
                : `${getConfig().consoleURL}${item.url}`
            }
            target="_blank"
            className="services-item is-document"
            key={index}
          >
            <div className="item-text-box">
              <p className="text-title">{item.title}</p>
              <p className="text-extra">{item.description}</p>
            </div>
          </a>
        );
      });
    }
    return null;
  };

  const onOk = () => {
    props.queryServiceStatus(
      props.selectedGameID,
      props.selectedEnv.id.toString(),
      props.selectedServiceConfig.id.toString()
    );
  };

  const renderApplyModal = () => {
    if (showApplyModal) {
      return (
        <ServicesApplyModal
          selectedGameID={props.selectedGameID}
          selectedEnv={props.selectedEnv}
          selectedServiceConfig={props.selectedServiceConfig}
          onClose={() => setShowApplyModal(false)}
          onOk={onOk}
          selectedServerStatus={props.selectedServerStatus}
          allServicesStatus={props.allServicesStatus}
          serviceAllEnvStatus={serviceAllEnvStatus}
        />
      );
    }
    return null;
  };

  if (!jsonConfig) {
    return null;
  }

  const configItem = servicesConfig?.find(
    (item) => item.id === serviceDescriptionModalID
  );

  return (
    <div className="services-box">
      <ApplyMenuComponent
        selectedServiceConfig={props.selectedServiceConfig}
        configItem={configItem}
      />
      <div className="services-right-content">
        {/* {renderApplySuccessTips()} */}
        {renderDescription(jsonConfig)}
        <div className="services-foot">{renderDocLinks(jsonConfig)}</div>
      </div>
      {renderApplyModal()}
    </div>
  );
};
